export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const SET_TABLES = 'SET_TABLES';
export const SET_GLOBAL_CHAT = 'SET_GLOBAL_CHAT';
export const SET_TABLE_CHAT = 'SET_TABLE_CHAT';
export const SET_RECENT_GAMES = 'SET_RECENT_GAMES';
export const SET_CONFIG = 'SET_CONFIG';
export const SET_TOP_EARNERS = 'SET_TOP_EARNERS';
export const SET_TOP_WINNERS = 'SET_TOP_WINNERS';
export const SET_ACTIVE_USERS = 'SET_ACTIVE_USERS';
export const RESET_APP = 'RESET_APP';
